import {Component, OnInit} from "@angular/core";
import {DatePickerInnerComponent} from "../datepicker-inner.component";

@Component({
  selector: "year-picker",
  styleUrls: [
    "./yearpicker.css"
  ],
  templateUrl: "./yearpicker.html"
})
export class YearPickerComponent implements OnInit {

  public datePicker: DatePickerInnerComponent;
  public title: string;
  public rows: any[] = [];

  public constructor(datePicker: DatePickerInnerComponent) {
    this.datePicker = datePicker;
  }


  onSelect(dtz: any) {
    if (!dtz.disabled) {
      this.datePicker.select(dtz.date);
    }
  }

  public ngOnInit(): void {
    const self = this;

    this.datePicker.stepYear = {years: this.datePicker.yearRange};

    this.datePicker.setRefreshViewHandler(function (): void {
      const years: any[] = new Array(this.yearRange);
      let date: Date;
      const start = self.getStartingYear(this.activeDate.getFullYear());

      for (let i = 0; i < this.yearRange; i++) {
        date = new Date(start + i, 0, 1);
        date = this.fixTimeZone(date);
        years[i] = this.createDateObject(date, "year");
        years[i].uid = this.uniqueId + "-" + i;
      }

      self.title = [years[0].label,
        years[this.yearRange - 1].label].join(" - ");
      self.rows = this.split(years, self.datePicker.yearColLimit);
    }, "year");

    this.datePicker.setCompareHandler(function (date1: Date, date2: Date): number {
      return date1.getFullYear() - date2.getFullYear();
    }, "year");

    this.datePicker.refreshView();
  }

  protected getStartingYear(year: number): number {
    // todo: parseInt
    return ((year - 1) / this.datePicker.yearRange) * this.datePicker.yearRange + 1;
  }
}
